export class  MatterportConfig {
  key!: string;
  hideFullscreen!: boolean;
  hideHelp!: boolean;
  additionalParams?: string;
  fileCacheSize?: number;
}
